export class ApproveRequestDetails{
    EmployeeNo : string;
}